import { useCart } from "../context/CartContext";

const CartButton = () => {
  const { itemCount, setIsOpen } = useCart();

  return (
    <button
      onClick={() => setIsOpen(true)}
      className="fixed top-2 right-2 md:top-6 md:right-6 z-40 bg-coolDark text-coolPaper rounded-full w-9 h-9 md:w-14 md:h-14 flex items-center justify-center shadow-lg hover:bg-rust transition-colors"
      aria-label="Open cart"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4 md:w-6 md:h-6"
      >
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
        <path d="M3 6h18" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-rust text-coolPaper text-[10px] md:text-xs font-bold rounded-full w-4 h-4 md:w-6 md:h-6 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </button>
  );
};

export default CartButton;
